export default __webpack_public_path__ + "static/media/glassblown-nessie.09eafb0e.webp";